import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from 'rebook/apps/base/components/Button';
import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import pluralize from 'rebook/apps/utils/text/pluralize';
import uaDetector from 'rebook/apps/utils/uaDetector';
import SocialShareMenu from 'rebook/apps/base/components/SocialShareMenu';

import styles from './style.scss';


class AuthorDetailHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoverOnFavoriteButton: false,
    };
    this.buttonRef = React.createRef();
  }

  handleMouseOver(isMobile) {
    if (isMobile) {
      return null;
    }
    this.setState({ hoverOnFavoriteButton: true });
  }

  handleMouseLeave(isMobile) {
    if (isMobile) {
      return null;
    }
    this.setState({ hoverOnFavoriteButton: false });
  }

  getFollowedButtonText(mouseOn, isMobile) {
    const elem = mouseOn && !isMobile
      ? (
        <div className={styles.unsubscribeText}>
          Отписаться
        </div>
      )
      : (
        <div className={styles.favoriteText}>
          В избранном
        </div>
      );
    return elem;
  }

  render() {
    const { hoverOnFavoriteButton } = this.state;
    const { photo, name, booksCount, authorUrl, handleAddToFavorite, isFollowedByUser, isLoading } = this.props;
    const UA = navigator && navigator.userAgent ? navigator.userAgent : null;
    if (!UA) {
      return null;
    }
    const isMobile = uaDetector.isMobile(UA);

    const buttonStyles = classNames({
      [styles.unsubscribeButton]: isFollowedByUser && hoverOnFavoriteButton,
      [styles.inFavoritesButton]: isFollowedByUser && !hoverOnFavoriteButton,
      'jest-unsubscribe-from-author': isFollowedByUser,
      [styles.addToFavoritesButton]: !isFollowedByUser,
      'jest-subscribe-to-author': !isFollowedByUser,
    });
    return (
      <section className={styles.wrapper}>
        <div className={styles.blurredImageWrapper}>
          <CroppedImage className={styles.cover}
            height="128"
            type="resized"
            src={photo} />
        </div>
        <div className={styles.container}>
          <div className={styles.image}>
            <CroppedImage
              type="resized"
              height="128"
              className={styles.photo}
              src={photo} />
          </div>
          <div className={styles.authorInfoBlock}>
            <div className={styles.paddingBlock} />
            <h1 className={styles.name}>
              {name}
            </h1>
            <span className={styles.subtitle}>
              {booksCount} {pluralize(booksCount, 'книга', 'книги', 'книг')}
            </span>
            <div className={styles.addToFavorites}>
              <Button buttonRef={this.buttonRef} extraClassName={buttonStyles}
                isInProgress={isLoading}
                handleClick={() => {
                  this.buttonRef.current.blur();
                  handleAddToFavorite();
                }}
                handleMouseOver={() => { this.handleMouseOver(isMobile); }}
                handleMouseLeave={() => { this.handleMouseLeave(isMobile); }}>
                {isFollowedByUser
                  ? (
                    this.getFollowedButtonText(hoverOnFavoriteButton, isMobile)
                  )
                  : (
                    <div className={styles.inFavoritesText}>
                      Добавить в избранное
                    </div>
                  )}
              </Button>
              <div className={styles.addToFavoritesInfo}>
                <span>Мы отправим вам уведомление, как только в каталоге появятся новые книги автора</span>
              </div>
            </div>
          </div>
          <div className={styles.linksContainer}>
            <div className={styles.separator} />
            {authorUrl && (
              <SocialShareMenu theme="white" url={authorUrl} utmCampaign="author" imageUrl={photo} />
            )}
          </div>
        </div>
      </section>
    );
  }
};

AuthorDetailHeader.propTypes = {
  name: PropTypes.string.isRequired,
  photo: PropTypes.string,
  booksCount: PropTypes.number,
};

AuthorDetailHeader.defaultProps = {
  photo: '',
  name: '',
  booksCount: 0,
};

export default AuthorDetailHeader;
